export default "__VITE_ASSET__BsJ4LCKu__"